import { useDuplicateTourMutation } from '@carboncopyco/data';
import type { Tour } from '@carboncopyco/types';
import { ConfirmAlert, notify } from '@carboncopyco/ui';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';

interface DuplicateTourModalProps {
  show: boolean;
  organizationId: string;
  tourId: number;
  goToDuplicatedTour?: (tour: Tour) => void;
  onClose: () => void;
}

export const DuplicateTourModal = ({
  onClose,
  show,
  organizationId,
  tourId,
  goToDuplicatedTour,
}: DuplicateTourModalProps) => {
  const [duplicateTour, { isLoading }] = useDuplicateTourMutation();
  const { trackEvent } = useAnalytics();
  const [isDisabled, setIsDisabled] = useBoolean();
  const location = 'tour_info_page_duplicate_demo_modal';
  return (
    <ConfirmAlert
      show={show}
      title="Duplicate this tour?"
      containerClass="w-ds-normal-modal"
      description="A new tour will be created as a copy of this one."
      noSecondButton
      onConfirm={() => {
        setIsDisabled.setTrue();
        trackEvent(AnalyticsTrackEventName.TOUR_CLICK_DUPLICATE_APPROVE, {
          location,
        });
        duplicateTour({ organizationId, id: tourId })
          .unwrap()
          .then((newTour) => goToDuplicatedTour?.(newTour))
          .catch(() => notify.error('Error duplicating tour'))
          .finally(() => {
            setIsDisabled.setFalse();
            onClose();
          });
      }}
      yesLabel="Duplicate"
      onClose={() => {
        trackEvent(AnalyticsTrackEventName.TOUR_CLICK_DUPLICATE_CANCEL, {
          location,
        });
        onClose();
      }}
      loading={isLoading}
      disabled={isDisabled}
    />
  );
};
